<template>
  <!-- https://loading.io/css/ -->
  <div class="lds-spinner">
    <div
      v-for="i in numDivs"
      :key="'spinner-animation-div-' + i"
    />
  </div>
</template>

<script>
const ID = 'spinner-animation-styles';

export default {
  props: {
    color: {
      type: String,
      default: '#000000',
    },
    size: {
      type: Number,
      default: 80,
    },
    thickness: {
      type: Number,
      default: 6,
    },
  },
  data() {
    return {
      numDivs: 12,
    };
  },
  computed: {
    styles() {
      return `
        .lds-spinner {
          width: ${this.size}px;
          height: ${this.size}px;
        }
        .lds-spinner div {
          transform-origin: ${this.size / 2}px ${this.size / 2}px;
        }
        .lds-spinner div:after {
          top: 3px;
          left: ${this.size / 2 - 3}px;
          width: ${this.thickness}px;
          height: ${this.size / 4 - 2}px;
          background: ${this.color};
        }
      `;
    },
  },
  watch: {
    styles: function () {
      this.applyStyles();
    },
  },
  mounted() {
    this.applyStyles();
  },
  methods: {
    applyStyles() {
      // Cleanup old styles first if needed.
      const el = document.getElementById(ID);
      if (el) {
        el.parentNode.removeChild(el);
      }

      const style = document.createElement('style');
      style.id = ID;
      style.type = 'text/css';
      document.head.appendChild(style);
      style.innerHTML = this.styles;
    },
  },
};
</script>

<style scoped>
/* https://loading.io/css/ */
.lds-spinner {
  display: inline-block;
  position: relative;
  /* width: 80px; */
  /* height: 80px; */
}
.lds-spinner div {
  /* transform-origin: 40px 40px; */
  animation: lds-spinner 1.2s linear infinite;
}
.lds-spinner div:after {
  content: ' ';
  display: block;
  position: absolute;
  /* top: 3px; */
  /* left: 37px; */
  /* width: 6px; */
  /* height: 18px; */
  border-radius: 20%;
  /* background: black; */
}

.lds-spinner div:nth-child(1) {
  transform: rotate(0deg);
  animation-delay: -1.1s;
}
.lds-spinner div:nth-child(2) {
  transform: rotate(30deg);
  animation-delay: -1s;
}
.lds-spinner div:nth-child(3) {
  transform: rotate(60deg);
  animation-delay: -0.9s;
}
.lds-spinner div:nth-child(4) {
  transform: rotate(90deg);
  animation-delay: -0.8s;
}
.lds-spinner div:nth-child(5) {
  transform: rotate(120deg);
  animation-delay: -0.7s;
}
.lds-spinner div:nth-child(6) {
  transform: rotate(150deg);
  animation-delay: -0.6s;
}
.lds-spinner div:nth-child(7) {
  transform: rotate(180deg);
  animation-delay: -0.5s;
}
.lds-spinner div:nth-child(8) {
  transform: rotate(210deg);
  animation-delay: -0.4s;
}
.lds-spinner div:nth-child(9) {
  transform: rotate(240deg);
  animation-delay: -0.3s;
}
.lds-spinner div:nth-child(10) {
  transform: rotate(270deg);
  animation-delay: -0.2s;
}
.lds-spinner div:nth-child(11) {
  transform: rotate(300deg);
  animation-delay: -0.1s;
}
.lds-spinner div:nth-child(12) {
  transform: rotate(330deg);
  animation-delay: 0s;
}
@keyframes lds-spinner {
  0% {
    opacity: 0.33;
  }
  100% {
    opacity: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/SpinnerAnimation.vue